<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VmzkXT/tc-custom/9780063009493.jpg?1718106102676" alt="This image is the cover for the book Raceless"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Raceless
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A <i>Bustle</i> Most Anticipated Debut of the Year</b></p><p><b>From <i>The Guardian</i>’s Georgina Lawton, a moving examination of how racial identity is constructed—through the author’s own journey grappling with secrets and stereotypes, having been raised by white parents with no explanation as to why she looked black.</b></p><p>Raised in sleepy English suburbia, Georgina Lawton was no stranger to homogeneity. Her parents were white; her friends were white; there was no reason for her to think she was any different. But over time her brown skin and dark, kinky hair frequently made her a target of prejudice. In Georgina’s insistently color-blind household, with no acknowledgement of her difference or access to black culture, she lacked the coordinates to make sense of who she was.</p><p>It was only after her father’s death that Georgina began to unravel the truth about her parentage—and the racial identity that she had been denied. She fled from England and the turmoil of her home-life to live in black communities around the globe—the US, the UK, Nicaragua, Cuba, the Dominican Republic, Vietnam, and Morocco—and to explore her identity and what it meant to live in and navigate the world as a black woman. She spoke with psychologists, sociologists, experts in genetic testing, and other individuals whose experiences of racial identity have been fraught or questioned in the hopes of understanding how, exactly, we identify ourselves.</p><p><i>Raceless </i>is an exploration of a fundamental question: what constitutes our sense of self? Drawing on her personal experiences and the stories of others, Lawton grapples with difficult questions about love, shame, grief, and prejudice, and reveals the nuanced and emotional journey of forming one’s identity.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Georgina Lawton
      </h2>
      
      <p class="authorDescription body article"><P>Georgina Lawton is a journalist, speaker, writer, and host of <I>The Secrets in Us</I> podcast. Previously a columnist for <I>The Guardian</I>, she has also written for <I>VICE</I>, <I>Marie Claire</I>, <I>Refinery29</I>, <I>Bustle</I>, <I>The Times (London)</I>, <I>Stylist</I>, <I>Time Out London</I>, and other outlets, where she writes about identity, travel, and culture. She lives in London.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsPublishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?131b047e